export default __webpack_public_path__ + "static/media/icon-nota-sencilla.81ffd07b.svg";